import { ApolloError } from "@apollo/client";
import * as Sentry from "@sentry/react";

// Postgres constraint violations arrive through Apollo as raw error text.
// Translate the common ones into something presentable.
const DUPLICATE_EMAIL_CONSTRAINT = "users_email_unique_when_not_null_idx";

export const describeMutationError = (
  error: unknown,
  fallback: string
): string => {
  const message = error instanceof Error ? error.message : String(error);

  if (message.includes(DUPLICATE_EMAIL_CONSTRAINT)) {
    return "A user with that email already exists.";
  }

  return fallback;
};

const ENV = import.meta.env.VITE_NODE_ENV;
export const useLogError = () => {
  return (error: any, extra?: any) => {
    if (ENV === "development") {
      console.error(error, extra);
    } else {
      let message = "",
        formattedError;
      if (error instanceof ApolloError) {
        message = error.message;
        formattedError = error.graphQLErrors?.[0];
      } else {
        message = error;
        formattedError = error;
      }

      Sentry.captureException(formattedError, {
        ...{ extra, env: ENV, message },
      });
    }
  };
};
